import React, {useCallback} from 'react';
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import type {Option, SelectionResult} from "../../components/visualization/api-dropdown-filter/ApiDropdownTypes";
import type {PageResponse} from "../../services/ApiTypes";
import {
    ApiDropdownFilterComponent,
    DEFAULT
} from "../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";

type Selection = SelectionResult<string>;
export const SearchL1Autocomplete: React.FC = observer(() => {
    const {bagStore, materializedApi} = useStores();
    const selection: Selection = bagStore.advanced.filters.category_l1 ?? DEFAULT;
    const filter = bagStore.advanced.filterQueryParamsL1;
    const getOptions = useCallback(
        search => (bagStore.advanced.databagId && bagStore.advanced.ready) ? materializedApi.searchInsightL1(bagStore.advanced.databagId, filter, search)
            .then<PageResponse<Option>>(resp => ({
                count: resp.data.length,
                next: '',
                previous: '',
                results: resp.data.map(([l1, total_spend]) => ({
                    id: l1,
                    label: l1,
                    subTotalSpend: Number(total_spend),
                    obj: ({id: l1, total_spend}),
                }))
            })) : null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [bagStore.advanced.databagId, bagStore.advanced.ready, filter]
    );
    if (!bagStore.advanced.ready) return <></>;
    return <ApiDropdownFilterComponent
        selection={selection}
        label="Filter L1"
        enableLabelStatus
        getOptions={getOptions}
        onSelectionChange={selection => bagStore.advanced.categoryL1FilterChanged(selection as Selection)}
        buttonProps={{fullWidth: true, sx: {height: '100%'}}}
    />

    // <Autocomplete
    //     options={bagStore.advanced.spendPerActiveL1DataStringArr}
    //     value={bagStore.advanced.filters.category?.[0] || ''}
    //     disableCloseOnSelect
    //     getOptionLabel={(option) => option ? option : ' Select L1'}
    //     renderOption={(props, option) => (
    //         <li {...props}>
    //             <Grid container>
    //                 <Grid size={6}>
    //                     {option ? option : '-'}
    //                 </Grid>
    //                 <Grid size={6}>
    //                     <CurrencyComponent v={bagStore.advanced.getActiveL1Spend(option)} nDigits={3}/>
    //                 </Grid>
    //             </Grid>
    //         </li>
    //     )}
    //     onChange={(_, value) => {
    //         if (value) {
    //             const categoryL1 = [value] as CategoryFilter;
    //             bagStore.advanced.categoryFilterChanged(categoryL1);
    //         } else {
    //             bagStore.advanced.categoryFilterChanged(null);
    //         }
    //     }}
    //     renderInput={(params) => (
    //         <TextField {...params} label=" Filter L1"/>
    //     )}
    // />
})
